import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import './LanguageSelector.css';

const languages = [
  { code: 'ja', label: '日本語' },
  { code: 'en', label: 'English' },
  { code: 'zh', label: '中文' }
];

export default function LanguageSelector() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const currentLang = i18n.language;

  const handleChange = (e) => {
    const newLang = e.target.value;
    i18n.changeLanguage(newLang);
    localStorage.setItem('i18nextLng', newLang);

    // クエリパラメータを更新
    const params = new URLSearchParams(location.search);
    params.set('lang', newLang);

    navigate({
      pathname: location.pathname,
      search: `?${params.toString()}`
    });
  };

  return (
    <div className="language-select-wrapper">
      <select
        className="language-select"
        value={currentLang}
        onChange={handleChange}
      >
        {languages.map(lang => (
          <option key={lang.code} value={lang.code}>
            {lang.label}
          </option>
        ))}
      </select>
    </div>
  );
}
